/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'react-i18next'
import { Avatar } from '@mui/material'
import { PRIMARY_PINK, PRIMARY_GRASS_GREEN, PRIMARY_ORANGE, PRIMARY_TRANSPARENT_GREEN } from 'utils/customizedTheme'
import { useNavigate } from 'react-router-dom'
import { translateGradeLevel } from 'utils/helpers'


const StudentCard = ({ student, learningStyle=null, step=1 }) => {


  const { t } = useTranslation()
  const navigate = useNavigate()
  
  const steps = [
    {},
    {title: `1. ${t('special.progress-monitoring')}`, color: PRIMARY_GRASS_GREEN,},
    {title: `3. ${t('special.referral')}`, color: PRIMARY_ORANGE},
    {title: `4. ${t('special.create-iep')}`, color: PRIMARY_PINK, },
  ]

  const learningCategories = learningStyle?.categories.map((category) => {
    return {
      name: category.title,
      value: category.percentage,
      fill: category.color_hex_code,
    }
  })


  return (    
    <div style={{
      background: '#fff',
      border: '1px solid #ccc', 
      borderRadius: '20px', 
      padding: '15px',
      width: '100%',
      margin: '1px'
    }}
    >
    <table><tbody><tr>
        {

          <td><div style={{ width: '100', textAlign: 'center', paddingRight: '10px', cursor: 'pointer'  }} 
           onClick={() => navigate(`/students/edit/${student.id}`)}>
            <Avatar
                      sx={{
                        bgcolor: PRIMARY_TRANSPARENT_GREEN,
                        width: 100,
                        height: 100,
                        display: 'flex',
                        alignItems: 'center',
                        textAlign: 'center',
                        margin: 'auto'
                      }}
                      variant='circular'
                      src={student.avatar}
                    >
            </Avatar>
            <div style={{ marginTop: '10px' }}>
               { student.first_name } {student.last_name}        
            </div>
          </div></td>
        }
        <td style={{ verticalAlign: 'top', paddingTop: '14px' }}>
          <div style={{ fontSize: '16px', lineHeight: '24px', textAlign: 'left' }} className="avatar-info">
              <div style={{ marginTop: '1px' }}>#{ student.academic_id }</div>
              <div style={{ marginTop: '1px' }}>{ translateGradeLevel(student.grade_level) }</div>  
              <div>{t('common.rti-tier')}: {student.tier}</div>
          </div>
        </td>
    </tr></tbody></table>


      {step && 
        <div style={{ marginTop: '10px' }}>
          <div style={{ color: steps[step].color, marginBottom: '5px' }}>
            {steps[step].title}
          </div>
          <div style={{ marginRight: '0px' }}>
            <div className='progress-bar'>
              <div className='progress-bar-fill' style={{ background: steps[step].color, width: (student.baseline_score ?? '0')+'%' }}>
                <div className='progress-bar-percent'>{student.baseline_score ?? 0}%</div>
              </div>
            </div>
            <div className='progress-bar-baseline'>
              <div className='progress-bar-baseline-fill' style={{ width: '50%' }}>
                <div className='progress-bar-baseline-percent'>{t('rti.baseline')}: 51%</div>
                <div className='progress-bar-baseline-line'></div>
              </div>
            </div>
          </div>
        </div>
      }

      {learningStyle?.is_taken && <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', marginTop: '20px' }}>


        {learningCategories.map(c => <div key={c.name} style={{ display: 'flex', alignItems: 'center', width: '100%'}}>

            <div style={{ width: '30%' }}>{c.name}</div>

            <div style={{ width: '70%', backgroundColor: '#fdf7e7', position: 'relative', borderRadius: '10px', overflow: 'hidden' }}>
               <div style={{ width: c.value+'%', backgroundColor: c.fill, height: '30px' }}></div>
               <div style={{ position: 'absolute', top: '5px', right: '10px' }}>{ c.value }%</div>
            </div>

          </div>)}
        
        
      </div>}

    </div>
  )
}

export default StudentCard
